import { Card, Col, Row, Table } from 'react-bootstrap'

const cardStyle = {
  border: 'none',
  boxShadow: '0 2px 12px rgba(0,0,0,0.04)',
  borderRadius: '12px',
  padding: '1.5rem',
  marginBottom: '1.5rem',
  backgroundColor: '#fff'
}

const tableHeaderStyle = {
  fontSize: '14px',
  fontWeight: '600',
  color: '#333333',
  letterSpacing: '0.5px',
  backgroundColor: '#f8f9fa',
  borderBottom: '2px solid #e9ecef'
}

const TableItem = ({ detail }) => {
  return (
    <Card style={cardStyle}>
      <Card.Body className="p-0">
        <Row>
          <Col md={12} className="mb-3">
            <h5
              className="fw-bold text-uppercase text-secondary"
              style={{ fontSize: '0.9rem' }}
            >
              ITEM RECEIPT DETAILS
            </h5>
          </Col>
          <Col md={12} className="">
            <Table
              hover
              responsive
              className="mb-0"
              size="sm"
              style={{ fontSize: '12px' }}
            >
              <thead>
                <tr>
                  <th
                    className="p-2 align-middle"
                    style={{ ...tableHeaderStyle, width: '30%' }}
                  >
                    Item Code - Name
                  </th>
                  <th className="p-2 align-middle" style={tableHeaderStyle}>
                    Batch
                  </th>
                  <th
                    className="p-2 text-end align-middle"
                    style={tableHeaderStyle}
                  >
                    DO Pack
                  </th>
                  <th
                    className="p-2 text-end align-middle"
                    style={tableHeaderStyle}
                  >
                    DO Qty
                  </th>
                  <th
                    className="p-2 text-end align-middle"
                    style={tableHeaderStyle}
                  >
                    Accepted Pack
                  </th>
                  <th
                    className="p-2 text-end align-middle"
                    style={tableHeaderStyle}
                  >
                    Accepted Qty
                  </th>
                  <th
                    className="p-2 text-end align-middle"
                    style={tableHeaderStyle}
                  >
                    Quarantine Pack
                  </th>
                  <th
                    className="p-2 text-end align-middle"
                    style={tableHeaderStyle}
                  >
                    Quarantine Qty
                  </th>
                  <th
                    className="p-2 text-end align-middle"
                    style={tableHeaderStyle}
                  >
                    Rejected Pack
                  </th>
                  <th
                    className="p-2 text-end align-middle"
                    style={tableHeaderStyle}
                  >
                    Rejected Qty
                  </th>
                </tr>
              </thead>
              <tbody>
                {detail && !detail.receipt_detail?.length && (
                  <tr>
                    <td
                      className="p-2 align-middle fw-bold text-center"
                      colSpan={10}
                    >
                      No data
                    </td>
                  </tr>
                )}
                {detail &&
                  detail?.receipt_detail?.length > 0 &&
                  detail?.receipt_detail?.map((receipt_detail, i) => (
                    <tr key={i}>
                      <td className="p-2 align-middle">
                        {receipt_detail?.item_code} -{' '}
                        {receipt_detail?.item_name}
                      </td>
                      <td className="p-2 align-middle">
                        {receipt_detail?.batch}
                      </td>
                      <td className="p-2 text-end align-middle">
                        {receipt_detail?.do_pack} {receipt_detail?.do_pack_uom}
                      </td>
                      <td className="p-2 text-end align-middle">
                        {receipt_detail?.do_qty} {receipt_detail?.do_uom}
                      </td>
                      <td className="p-2 text-end align-middle">
                        {receipt_detail?.acc_pack}{' '}
                        {receipt_detail?.acc_pack_uom}
                      </td>
                      <td className="p-2 text-end align-middle">
                        {receipt_detail?.acc_qty} {receipt_detail?.acc_uom}
                      </td>
                      <td className="p-2 text-end align-middle">
                        {receipt_detail?.quarantine_pack}{' '}
                        {receipt_detail?.quarantine_pack_uom}
                      </td>
                      <td className="p-2 text-end align-middle">
                        {receipt_detail?.quarantine_qty}{' '}
                        {receipt_detail?.quarantine_uom}
                      </td>
                      <td className="p-2 text-end align-middle">
                        {receipt_detail?.damaged_pack}{' '}
                        {receipt_detail?.damaged_pack_uom}
                      </td>
                      <td className="p-2 text-end align-middle">
                        {receipt_detail?.damaged_qty}{' '}
                        {receipt_detail?.damaged_uom}
                      </td>
                    </tr>
                  ))}
              </tbody>
            </Table>
          </Col>
        </Row>
      </Card.Body>
    </Card>
  )
}

export default TableItem
